import { DetailComponent } from './detail/detail.component';
import { PendingsListComponent } from './pendings-list/pendings-list.component';
import { ResultComponent as RequestMoreInfoResult } from './detail/request-more-info/result/result.component';
import { ResultComponent as ApprovedResult } from './detail/approve-request/result/result.component';
import { ResultComponent as DelegatedResultComponent } from './detail/delegate/result/result.component';
import { ResultComponent as RejectedResultComponent } from './detail/reject/result/result.component';

export const ApproveChildRoutes = [
  {
    path: '',
    component: PendingsListComponent,
  },
  {
    path: 'detail/:ofuscatedData',
    component: DetailComponent,
  },
  {
    path: 'detail/:ofuscatedData/approved/:ofuscatedResult',
    component: ApprovedResult,
  },
  {
    path: 'detail/:ofuscatedData/requested-more-info/:ofuscatedResult',
    component: RequestMoreInfoResult,
  },
  {
    path: 'detail/:ofuscatedData/delegated/:ofuscatedResult',
    component: DelegatedResultComponent,
  },
  {
    path: 'detail/:ofuscatedData/rejected/:ofuscatedResult',
    component: RejectedResultComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/dashboard',
  },
];
